var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMouseLeftClickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "myImg",
    className: "mainimage",
    style: {
      fill: "black"
    },
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mouse Left Button SVG icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M509,10c-167.1,0-336.3,83.9-336.3,244.3v408.5C172.7,843.2,319.5,990,500,990c180.5,0,327.3-146.8,327.3-327.3V254.3C827.3,86.4,662.3,10,509,10z M765.7,662.7c0,146.5-119.2,265.7-265.7,265.7c-146.5,0-265.7-119.2-265.7-265.7v-191c55,16.6,158.5,41.8,280.9,41.8c78.4,0,164.4-10.5,250.4-40V662.7z M765.7,408c-224.5,85.8-462.7,21.2-531.3-1V254.3c0-118.6,141.5-182.7,274.7-182.7c127.8,0,256.7,56.5,256.7,182.7V408z M534.7,143v223.3c0,17-13.8,30.8-30.8,30.8c-17,0-30.8-13.8-30.8-30.8V143c0-17,13.8-30.8,30.8-30.8C520.8,112.2,534.7,126,534.7,143z M435.8,120.1V405c-43.6,7.7-172-28.2-172-28.2C230.5,122.7,435.8,120.1,435.8,120.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseLeftClickIcon);
export default __webpack_public_path__ + "static/media/mouse-left-click-icon.2947e85cb143b39ed64ceec5982d4d66.svg";
export { ForwardRef as ReactComponent };